export const MiscIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="49.428"
    height="32.759"
    viewBox="0 0 49.428 32.759"
  >
    <g id="Icon_Sonstige" transform="translate(-35.403 -37.431)">
      <g id="Gruppe_935" data-name="Gruppe 935" transform="translate(37.636 37.931)">
        <line
          id="Linie_117"
          data-name="Linie 117"
          x2="34.052"
          transform="translate(0.199 23.66)"
          fill="none"
          stroke="var(--color-primary)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Pfad_586"
          data-name="Pfad 586"
          d="M38.783,72.542l-.089-13.267s.575-4.588,3.958-4.588"
          transform="translate(-38.694 -44.283)"
          fill="none"
          stroke="var(--color-primary)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Pfad_587"
          data-name="Pfad 587"
          d="M81.084,66.43s-7.783,1.415-2.919-4.246c0,0,3.968-3.449,4.726,1.681C82.891,63.865,83.472,66.341,81.084,66.43Z"
          transform="translate(-53.051 -46.695)"
          fill="none"
          stroke="var(--color-primary)"
          strokeWidth="1"
        />
        <path
          id="Pfad_588"
          data-name="Pfad 588"
          d="M47.48,66.546S55.263,67.961,50.4,62.3c0,0-3.968-3.449-4.726,1.681C45.673,63.981,45.092,66.457,47.48,66.546Z"
          transform="translate(-41.316 -46.739)"
          fill="none"
          stroke="var(--color-primary)"
          strokeWidth="1"
        />
        <line
          id="Linie_118"
          data-name="Linie 118"
          x2="31.281"
          transform="translate(1.609 10.311)"
          fill="none"
          stroke="var(--color-primary)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Pfad_589"
          data-name="Pfad 589"
          d="M91.772,72.5l.088-13.267s-.247-4.616-3.63-4.616"
          transform="translate(-57.473 -44.256)"
          fill="none"
          stroke="var(--color-primary)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Pfad_590"
          data-name="Pfad 590"
          d="M43.644,47.682,47.558,38l9.353-.033,10.016-.034L71.8,48.28"
          transform="translate(-40.571 -37.931)"
          fill="none"
          stroke="var(--color-primary)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
      <path
        id="Pfad_592"
        data-name="Pfad 592"
        d="M40.142,52.119a9.219,9.219,0,0,0-2.3-.934c-1.088-.281-1.35-.137-1.44-.078a2.032,2.032,0,0,0,.078,2.762c.3.265.966.281,2.3.312,1.233.029,1.44-.075,1.567-.22C40.831,53.4,40.181,52.189,40.142,52.119Z"
        transform="translate(0 -4.961)"
        fill="#fff"
        stroke="var(--color-primary)"
        strokeWidth="1"
      />
      <path
        id="Pfad_593"
        data-name="Pfad 593"
        d="M89.36,51.875a9.243,9.243,0,0,1,2.3-.934c1.088-.28,1.35-.137,1.44-.078a2.032,2.032,0,0,1-.078,2.762c-.3.265-.966.281-2.3.311-1.233.029-1.44-.075-1.567-.22C88.671,53.161,89.321,51.946,89.36,51.875Z"
        transform="translate(-20.12 -4.869)"
        fill="#fff"
        stroke="var(--color-primary)"
        strokeWidth="1"
      />
      <g id="Gruppe_937" data-name="Gruppe 937" transform="translate(-8.827 5.239)">
        <circle
          id="Ellipse_106"
          data-name="Ellipse 106"
          cx="7.872"
          cy="7.872"
          r="7.872"
          transform="translate(77.415 48.707)"
          fill="#fff"
          stroke="var(--color-primary)"
          strokeWidth="1"
        />
        <circle
          id="Ellipse_107"
          data-name="Ellipse 107"
          cx="0.862"
          cy="0.862"
          r="0.862"
          transform="translate(80.27 55.718)"
          fill="var(--color-primary)"
        />
        <circle
          id="Ellipse_108"
          data-name="Ellipse 108"
          cx="0.862"
          cy="0.862"
          r="0.862"
          transform="translate(84.424 55.718)"
          fill="var(--color-primary)"
        />
        <circle
          id="Ellipse_109"
          data-name="Ellipse 109"
          cx="0.862"
          cy="0.862"
          r="0.862"
          transform="translate(88.578 55.718)"
          fill="var(--color-primary)"
        />
      </g>
    </g>
  </svg>
);

export const GlassIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="54.694"
    height="31.058"
    viewBox="0 0 54.694 31.058"
  >
    <g id="Icon_Glas" transform="translate(-39.811 -36.35)">
      <path
        id="Pfad_584"
        data-name="Pfad 584"
        d="M53.944,38.258c9.717-1.855,25.085-2.881,40.061,4.328l-7.07,24.322s-18.945-6.651-39.218,0L40.311,42.586a57.307,57.307,0,0,1,9.44-3.332"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_585"
        data-name="Pfad 585"
        d="M56.988,38.688v6.788l4.228,2.282-3.169,8.1V49.313l-4.373-1.555-.72-8.117"
        transform="translate(-3.044 -0.43)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export const WheelchangeIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="37.134"
    height="37.134"
    viewBox="0 0 37.134 37.134"
  >
    <g id="Icon_Raederwechsel" transform="translate(0.5 0.5)">
      <path
        id="Pfad_192"
        data-name="Pfad 192"
        d="M78.266,61.02,81.4,65.333A9.412,9.412,0,0,0,84.039,58.8a9.519,9.519,0,0,0-.1-1.317l-5.062,1.644A4.249,4.249,0,0,1,78.266,61.02Z"
        transform="translate(-56.529 -40.733)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_193"
        data-name="Pfad 193"
        d="M58.622,59.775a11.8,11.8,0,1,1,11.8-11.8A11.817,11.817,0,0,1,58.622,59.775Z"
        transform="translate(-40.555 -29.904)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_194"
        data-name="Pfad 194"
        d="M70.083,43.716a18.3,18.3,0,0,0,.139-2.209,18.091,18.091,0,0,0-.2-2.684l-.688.242-.282-1.606.705-.011a17.989,17.989,0,0,0-1.732-4.573l-.563.459-.813-1.415.652-.247a18.275,18.275,0,0,0-3.19-3.7l-.367.617L62.5,27.536l.53-.457a17.988,17.988,0,0,0-4.26-2.392l-.138.711L57.1,24.841l.348-.621a17.913,17.913,0,0,0-4.83-.78l.115.713H51.1l.116-.7a17.922,17.922,0,0,0-4.806.917l.353.634-1.531.558-.133-.7a18.061,18.061,0,0,0-4.2,2.51l.543.471L40.2,28.89l-.358-.6a18.167,18.167,0,0,0-3.1,3.781l.679.257-.816,1.413-.547-.446a17.963,17.963,0,0,0-1.617,4.619l.73.008L34.9,39.529l-.667-.232a17.941,17.941,0,0,0-.141,2.21,18.431,18.431,0,0,0,.2,2.684l.69-.241.282,1.606-.706.01a17.9,17.9,0,0,0,1.732,4.575l.563-.46.814,1.413-.655.25a18.162,18.162,0,0,0,3.191,3.7l.367-.615,1.25,1.049-.533.459a18.161,18.161,0,0,0,4.263,2.391l.134-.712,1.534.557-.347.622a18.019,18.019,0,0,0,4.826.779l-.116-.715h1.631l-.116.7a17.892,17.892,0,0,0,4.8-.917l-.355-.634,1.533-.556.133.7a18.174,18.174,0,0,0,4.195-2.51l-.544-.47,1.25-1.048.357.6a18.29,18.29,0,0,0,3.094-3.781l-.677-.258.818-1.411.544.443A17.976,17.976,0,0,0,69.863,45.1l-.732-.01.284-1.607Z"
        transform="translate(-34.087 -23.44)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_195"
        data-name="Pfad 195"
        d="M66.542,68.76a4.235,4.235,0,0,1-1-.124l-3.13,4.309a9.321,9.321,0,0,0,8.264,0l-3.129-4.309A4.257,4.257,0,0,1,66.542,68.76Z"
        transform="translate(-48.475 -46.398)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <circle
        id="Ellipse_27"
        data-name="Ellipse 27"
        cx="1.934"
        cy="1.934"
        r="1.934"
        transform="translate(16.134 16.132)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_196"
        data-name="Pfad 196"
        d="M75.755,47.755l5.079-1.649a9.468,9.468,0,0,0-6.667-4.832V46.6A4.347,4.347,0,0,1,75.755,47.755Z"
        transform="translate(-54.446 -32.5)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_197"
        data-name="Pfad 197"
        d="M56.781,59.127l-5.062-1.644a9.51,9.51,0,0,0-.1,1.317,9.415,9.415,0,0,0,2.641,6.534L57.39,61.02A4.249,4.249,0,0,1,56.781,59.127Z"
        transform="translate(-42.991 -40.733)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_198"
        data-name="Pfad 198"
        d="M60.568,46.6V41.275A9.459,9.459,0,0,0,53.9,46.106l5.079,1.649A4.319,4.319,0,0,1,60.568,46.6Z"
        transform="translate(-44.153 -32.5)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export const InspectionIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="36.651"
    height="35.28"
    viewBox="0 0 36.651 35.28"
  >
    <g id="Icon_Inspektion" transform="translate(0.5 0.495)">
      <path
        id="Pfad_199"
        data-name="Pfad 199"
        d="M74.094,68.205l5.691-6.158,7.576,7.575s1.831,1.952.452,3.473-2.756,2.835-2.756,2.835-1.9,1.5-3.921-.683C78.9,72.822,74.094,68.205,74.094,68.205Z"
        transform="translate(-55.482 -42.403)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_200"
        data-name="Pfad 200"
        d="M41.758,32.283l2.168-2.168,6.266,3.857-.148,1.712,6.2,6.2L53.421,44.5l-6.069-6.07-1.737.122Z"
        transform="translate(-41.758 -28.85)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_201"
        data-name="Pfad 201"
        d="M67.405,34.113l5.118,5.118,5.7-5.7s1.845,6.478-3,9.575-8.052.968-8.052.968L51.195,61.366s-2.239,2.492-5.212-1.143-.57-4.913-.57-4.913L62.557,39.468s-1-4.675.309-6.834a10,10,0,0,1,3.191-3.449,8.561,8.561,0,0,1,5.04-1.242c1.771.128,2.005.475,2.005.475Z"
        transform="translate(-42.919 -27.918)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export const CalendarCheckIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill={`var(--color-${props.color || "primary"})`}
    viewBox="0 0 448 512"
    className={props.className}
  >
    <path d="M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM331.3 283.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 361.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l112-112z" />
  </svg>
);

export const CalendarCheckBenefitsIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    id="calendar-check-regular"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    width="11.438"
    height="13.071"
    viewBox="0 0 11.438 13.071"
  >
    <g id="Gruppe_140" data-name="Gruppe 140">
      <g id="Gruppe_139" data-name="Gruppe 139">
        <path
          id="Pfad_143"
          data-name="Pfad 143"
          d="M10.212,1.634H8.987V.306A.306.306,0,0,0,8.68,0H7.659a.307.307,0,0,0-.307.307V1.634H4.085V.306A.307.307,0,0,0,3.778,0H2.758a.307.307,0,0,0-.307.307V1.634H1.225A1.225,1.225,0,0,0,0,2.859v8.987a1.225,1.225,0,0,0,1.225,1.225h8.987a1.225,1.225,0,0,0,1.225-1.225V2.859A1.225,1.225,0,0,0,10.212,1.634Zm-.153,10.212H1.378a.153.153,0,0,1-.153-.153V4.085h8.987v7.608a.153.153,0,0,1-.153.153ZM8.709,6.724l-3.633,3.6a.307.307,0,0,1-.434,0L2.726,8.393a.307.307,0,0,1,0-.433l.58-.576a.307.307,0,0,1,.434,0L4.867,8.521,7.7,5.708a.306.306,0,0,1,.433,0l.576.58a.307.307,0,0,1,0,.434Z"
          fill="var(--color-primary)"
        />
      </g>
    </g>
  </svg>
);

export const CheckBenefitsIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="15.647"
    height="15.647"
    viewBox="0 0 15.647 15.647"
  >
    <g id="Gruppe_925" data-name="Gruppe 925" transform="translate(-41.989 -529.378)">
      <path
        id="Pfad_495"
        data-name="Pfad 495"
        d="M353,299.117l1.5,1.416,2-.479.587,1.974,1.974.587-.479,2,1.416,1.5-1.416,1.5.479,2-1.974.587-.587,1.974-2-.479-1.5,1.416-1.5-1.416-2,.479-.587-1.974-1.974-.587.479-2-1.416-1.5,1.416-1.5-.479-2,1.974-.587.587-1.974,2,.479Z"
        transform="translate(-303.184 231.087)"
        fill="none"
        stroke="var(--color-primary)"
        strokeWidth="1.2"
      />
      <path
        id="Pfad_497"
        data-name="Pfad 497"
        d="M8.709,6.724l-3.633,3.6a.307.307,0,0,1-.434,0L2.726,8.393a.307.307,0,0,1,0-.433l.58-.576a.307.307,0,0,1,.434,0L4.867,8.521,7.7,5.708a.306.306,0,0,1,.433,0l.576.58a.307.307,0,0,1,0,.434Z"
        transform="translate(44.093 528.876)"
        fill="var(--color-primary)"
      />
    </g>
  </svg>
);

export const BonusBenefitsIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="13.926"
    height="13.398"
    viewBox="0 0 13.926 13.398"
  >
    <g id="Icon_Bonus" transform="translate(22043 -16254)">
      <g
        id="Rechteck_311"
        data-name="Rechteck 311"
        transform="translate(-22043 16254)"
        fill="none"
        stroke="var(--color-primary)"
        strokeWidth="1"
      >
        <rect width="13.926" height="13.398" rx="2" stroke="none" />
        <rect x="0.5" y="0.5" width="12.926" height="12.398" rx="1.5" fill="none" />
      </g>
      <path
        id="Pfad_567"
        data-name="Pfad 567"
        d="M-22032.3,16296v13.176"
        transform="translate(-3.88 -42)"
        fill="none"
        stroke="var(--color-primary)"
        strokeWidth="1"
      />
      <path
        id="Pfad_568"
        data-name="Pfad 568"
        d="M-22051,16315.5h13.084"
        transform="translate(8.421 -54.829)"
        fill="none"
        stroke="var(--color-primary)"
        strokeWidth="1"
      />
      <path
        id="Pfad_569"
        data-name="Pfad 569"
        d="M-22034.531,16410.086s-2.543-.914-3.508-1.383a1.565,1.565,0,0,1,0-2.715,1.571,1.571,0,0,1,2.23.955C-22035.572,16407.594-22034.531,16410.086-22034.531,16410.086Z"
        transform="translate(-1.651 -149.498)"
        fill="none"
        stroke="var(--color-primary)"
        strokeWidth="1"
      />
      <path
        id="Pfad_570"
        data-name="Pfad 570"
        d="M-22038.828,16410.086s2.543-.914,3.508-1.383a1.564,1.564,0,0,0,0-2.715,1.571,1.571,0,0,0-2.23.955C-22037.785,16407.594-22038.828,16410.086-22038.828,16410.086Z"
        transform="translate(2.798 -149.498)"
        fill="none"
        stroke="var(--color-primary)"
        strokeWidth="1"
      />
      <path
        id="Pfad_571"
        data-name="Pfad 571"
        d="M-22025.963,16418.512a5.478,5.478,0,0,0,4,2.273"
        transform="translate(-10.409 -158.266)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_572"
        data-name="Pfad 572"
        d="M-22021.961,16418.512a5.483,5.483,0,0,1-4,2.273"
        transform="translate(-14.068 -158.266)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export const CheckIcon = (props: { primary?: boolean; className?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className || "w-h h-5"}
    width="18.697"
    height="12.87"
    viewBox="0 0 18.697 12.87"
  >
    <path
      id="Pfad_579"
      data-name="Pfad 579"
      d="M-1812.618,15384.5l5.412,5.238,10.456-10.456"
      transform="translate(1814.032 -15377.869)"
      fill="none"
      stroke={props.primary ? "var(--color-primary)" : "#fff"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

export const CheckIconLight = (props: { primary: boolean; className: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className || "w-h h-5"}
    viewBox="0 0 448 512"
  >
    <path
      fill={props.primary ? "var(--color-primary)" : "#fff"}
      d="M443.3 100.7C449.6 106.9 449.6 117.1 443.3 123.3L171.3 395.3C165.1 401.6 154.9 401.6 148.7 395.3L4.686 251.3C-1.562 245.1-1.562 234.9 4.686 228.7C10.93 222.4 21.06 222.4 27.31 228.7L160 361.4L420.7 100.7C426.9 94.44 437.1 94.44 443.3 100.7H443.3z"
    />
  </svg>
);

export const XMarkIcon = (props: { primary: boolean; className: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    viewBox="0 0 320 512"
  >
    <path
      fill={props.primary ? "var(--color-primary)" : "#fff"}
      stroke={props.primary ? "var(--color-primary)" : "#fff"}
      d="M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6l-132.7 132.7c-6.253 6.253-16.37 6.253-22.63 0c-6.253-6.253-6.253-16.37 0-22.63L137.4 256L4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63c6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0c6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7C321.6 394.9 321.6 405.1 315.3 411.3z"
    />
  </svg>
);

export const SeasonalTireChangeIcon = (props: { primary: boolean; className: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    viewBox="0 0 640 512"
  >
    <path
      fill={props.primary ? "var(--color-primary)" : "#fff"}
      stroke={props.primary ? "var(--color-primary)" : "#fff"}
      d="M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l56-39.2c-7.2-7.9-13.4-16.7-18.4-26.2l-35.2 24.6-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 8.5 51c8.8-7.5 18.7-13.9 29.3-18.8L303.8 13.4zM208 120c-48.6 0-88 39.4-88 88c0 31 16 58.2 40.1 73.9c.6-12.5 2.9-24.5 6.8-35.7c-9.3-10-15-23.4-15-38.1c0-30.9 25.1-56 56-56c13.2 0 25.4 4.6 35 12.3c2.4-11 6.3-21.4 11.3-31.1C240.8 124.8 225 120 208 120zm87.3 297.7c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c4-7.9 .7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c3.9-7.9 .7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c4-7.9 .7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c4-7.9 .7-17.5-7.2-21.5zM304 192c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H290.9c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H557.3c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 114.6 402.9 96 368 96z"
    />
  </svg>
);

export const TireSparkleIcon = (props: { primary: boolean; className: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    viewBox="0 0 640 512"
  >
    <path
      fill={props.primary ? "var(--color-primary)" : "#fff"}
      stroke={props.primary ? "var(--color-primary)" : "#fff"}
      d="M0 256C0 164.5 48.8 80 128 34.3s176.8-45.7 256 0c60.5 34.9 103.2 92.4 120 158.4c-2.6-.4-5.3-.7-8-.7c-8.5 0-16.5 2.2-23.6 6C457.2 141.4 420.1 92.1 368 62c-69.3-40-154.7-40-224 0S32 176 32 256s42.7 154 112 194s154.7 40 224 0c9.9-5.7 19.3-12.2 28.1-19.2c9 3.4 18 6.8 27 10.1c.9 2.3 1.7 4.5 2.6 6.8C413 459 399 469 384 477.7c-79.2 45.7-176.8 45.7-256 0S0 347.5 0 256zm117.4-80C146 126.5 198.8 96 256 96s110 30.5 138.6 80c22 38.1 27.1 82.9 15.2 124.1c-13.4 5-26.9 10.1-40.3 15.1c.8-1.5 1.6-3.1 2.3-4.6c-20.6-6.7-41.3-13.4-61.9-20.1c.1-.1 0 0 .1-.1c-8.6 13.5-22.1 23.5-38 27.6c0 21.7 0 43.3 0 65c17.3-2.2 33.6-7.8 48-16.1c0 .2 0 .4 0 .6c0 .3 0 .6 0 .9c.1 10.9 3.8 21.1 10.1 29.4C307.6 409.6 282.2 416 256 416c-57.2 0-110-30.5-138.6-80s-28.6-110.5 0-160zM128 256c0 8.3 .8 16.3 2.3 24.2c20.6-6.7 41.2-13.5 61.8-20.2c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6c-3.4-4.6-6.7-9.3-10.1-13.9c-9.4-12.9-18.7-25.8-28.1-38.7C143.5 186.1 128 219.2 128 256zm12.2 54.6c18.3 38.8 55.5 66.9 99.8 72.4c0-21.7 0-43.3 0-65c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1zm54-166.7c9.4 12.9 18.7 25.9 28.1 38.8l10 13.8c7.4-2.9 15.4-4.5 23.7-4.5s16.3 1.6 23.6 4.5c12.7-17.5 25.5-35.1 38.2-52.6C299.5 133.8 278.4 128 256 128s-43.5 5.8-61.8 15.9zM224 256c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32zm81.5-40.8c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4c0 .1 0 .1 0 .2c20.6 6.7 41.2 13.4 61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6zM352 368c0-7.2 4.5-13.7 11.2-16.2c28.3-10.6 56.5-21.2 84.8-31.8c10.6-28.3 21.2-56.5 31.8-84.8c2.5-6.7 9-11.2 16.2-11.2s13.7 4.4 16.2 11.2c10.6 28.3 21.2 56.5 31.8 84.8c28.3 10.6 56.5 21.2 84.8 31.8c6.7 2.5 11.2 9 11.2 16.2s-4.4 13.7-11.2 16.2c-28.3 10.6-56.5 21.2-84.8 31.8c-10.6 28.3-21.2 56.5-31.8 84.8c-2.5 6.7-9 11.2-16.2 11.2s-13.7-4.4-16.2-11.2c-10.6-28.3-21.2-56.5-31.8-84.8c-28.3-10.6-56.5-21.2-84.8-31.8c-6.7-2.5-11.2-9-11.2-16.2zm59.1 0l48.2 17.9c8.6 3.2 15.5 10 18.7 18.7c6 16 12 32.1 18 48.1c6-16 12-32.1 18-48.1c3.2-8.6 10-15.5 18.7-18.7c16-6 32.1-12 48.1-18c-16-6-32.1-12-48.1-18c-8.6-3.2-15.5-10-18.7-18.7c-6-16-12-32.1-18-48.1c-6 16-12 32.1-18 48.1c-.1 .1 0 0-.1 .1c-3.2 8.6-10 15.5-18.7 18.7c-16 6-32.1 12-48.1 18z"
    />
  </svg>
);

export const TireUserIcon = (props: { primary: boolean; className: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    viewBox="0 0 640 512"
  >
    <path
      fill={props.primary ? "var(--color-primary)" : "#fff"}
      stroke={props.primary ? "var(--color-primary)" : "#fff"}
      d="M0 256C0 164.5 48.8 80 128 34.3s176.8-45.7 256 0c50.2 29 88.2 73.5 109.3 125.5c-11.3 .3-22.2 2.2-32.4 5.6C442 122.7 409.8 86.2 368 62c-69.3-40-154.7-40-224 0S32 176 32 256s42.7 154 112 194c54 31.2 117.8 38.1 176.2 20.6c-.1 1.9-.1 3.8-.2 5.7c0 .4 0 .8 0 1.2c.1 8.8 1.9 17.3 5.1 25c-65.5 18.3-136.6 10.1-197.1-24.8C48.8 432 0 347.5 0 256zm117.4-80C146 126.5 198.8 96 256 96s110 30.5 138.6 80c5.1 8.9 9.3 18.1 12.6 27.5c-14.5 18.9-23.2 42.6-23.2 68.3c0 20.4 5.5 39.5 15 56c-1.4 2.8-2.9 5.5-4.4 8.2C366 385.5 313.2 416 256 416s-110-30.5-138.6-80s-28.6-110.5 0-160zM128 256c0 8.3 .8 16.3 2.3 24.2c20.6-6.7 41.2-13.5 61.8-20.2c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6c-3.4-4.6-6.7-9.3-10.1-13.9c-9.4-12.9-18.7-25.8-28.1-38.7C143.5 186.1 128 219.2 128 256zm12.2 54.6c18.3 38.8 55.5 66.9 99.8 72.4c0-21.7 0-43.3 0-65c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1zm54-166.7c9.4 12.9 18.7 25.9 28.1 38.8l10 13.8c7.4-2.9 15.4-4.5 23.7-4.5s16.3 1.6 23.6 4.5c12.7-17.5 25.5-35.1 38.2-52.6C299.5 133.8 278.4 128 256 128s-43.5 5.8-61.8 15.9zM224 256c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32zm48 62c0 21.7 0 43.3 0 65c44.3-5.5 81.5-33.6 99.8-72.4c-20.6-6.7-41.3-13.4-61.9-20.1c.1-.1 0 0 .1-.1c-8.6 13.5-22.1 23.5-38 27.6zm33.5-102.8c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4c0 .1 0 .1 0 .2c20.6 6.7 41.2 13.4 61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6zM352 477.1c0-51.4 41.7-93.1 93.1-93.1c17 0 33.9 0 50.9 0s33.9 0 50.9 0c51.4 0 93.1 41.7 93.1 93.1c0 19.3-15.6 34.9-34.9 34.9c-72.7 0-145.5 0-218.2 0c-19.3 0-34.9-15.6-34.9-34.9zm32 0c0 1.6 1.3 2.9 2.9 2.9c72.7 0 145.5 0 218.2 0c1.6 0 2.9-1.3 2.9-2.9c0-33.7-27.4-61.1-61.1-61.1c-33.9 0-67.9 0-101.8 0c-33.7 0-61.1 27.4-61.1 61.1zM426.7 232c14.3-24.8 40.7-40 69.3-40s55 15.2 69.3 40s14.3 55.2 0 80s-40.7 40-69.3 40s-55-15.2-69.3-40s-14.3-55.2 0-80zm27.7 16c-8.6 14.9-8.6 33.1 0 48s24.4 24 41.6 24s33-9.1 41.6-24s8.6-33.1 0-48s-24.4-24-41.6-24s-33 9.1-41.6 24z"
    />
  </svg>
);

export const WareHouseIcon = (props: { primary: boolean; className: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    viewBox="0 0 640 512"
  >
    <path
      fill={props.primary ? "var(--color-primary)" : "#fff"}
      stroke={props.primary ? "var(--color-primary)" : "#fff"}
      d="M320 6.8l5.9 2.3 304 120 10.1 4V144 496v16H608V496 154.9L320 41.2 32 154.9V496v16H0V496 144 133.1l10.1-4 304-120L320 6.8zM96 192h16H528h16v16V496v16H512V496 224H128V496v16H96V496 208 192zM352 368h32 64 32v32 80 32H448 192 160V480 288 256h32H320h32v32 48 32zm-32 32H192v80H320V400zm32 80h96V400H352v80zM320 368V288H192v80H320z"
    />
  </svg>
);

export const CloseIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className || "h-6 w-6 text-primary"}
    fill="none"
    viewBox="0 0 24 24"
    stroke={props.color || "var(--color-primary)"}
    strokeWidth="2"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  </svg>
);

export const CaretDownIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="16"
    height="10"
    viewBox="0 0 16 10"
  >
    <defs>
      <path
        id="a"
        d="M7.758 6.271L13.436.682 14.129 0l1.386 1.364-.693.683-5.678 5.589L7.758 9l-.694-.682-6.37-6.271L0 1.364 1.386 0l.693.682 5.679 5.59z"
      />
    </defs>
    <use
      fill={`var(--color-${props.color || "primary"})`}
      fillRule="nonzero"
      transform="translate(.5 .5)"
      xlinkHref="#a"
    />
  </svg>
);

export const ArrowDownIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    viewBox="0 0 384 512"
  >
    <path
      fill="var(--color-neutral-700)"
      d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    />
  </svg>
);

export const BadgeCheckIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <g id="badge-check-solid" transform="translate(1.5 1.5)">
      <g id="Pfad_126" data-name="Pfad 126" fill="none">
        <path
          d="M15,7.5a2.577,2.577,0,0,0-1.673-2.414A2.578,2.578,0,0,0,9.914,1.673a2.578,2.578,0,0,0-4.828,0A2.578,2.578,0,0,0,1.673,5.086a2.578,2.578,0,0,0,0,4.828,2.578,2.578,0,0,0,3.413,3.413,2.578,2.578,0,0,0,4.828,0,2.578,2.578,0,0,0,3.413-3.413A2.577,2.577,0,0,0,15,7.5ZM10.758,6.2l-3.84,3.808a.322.322,0,0,1-.455,0L4.245,7.774a.321.321,0,0,1,0-.456l.762-.756a.322.322,0,0,1,.456,0L6.7,7.808,9.548,4.983a.322.322,0,0,1,.455,0l.757.763a.323.323,0,0,1,0,.456Z"
          stroke="none"
        />
        <path
          d="M 7.5 0 C 6.395999908447266 0 5.451999664306641 0.694000244140625 5.086000442504883 1.673000335693359 C 4.136000633239746 1.243000984191895 2.976001739501953 1.415000915527344 2.196999549865723 2.196999549865723 C 1.414999961853027 2.979000091552734 1.241999626159668 4.13700008392334 1.673000335693359 5.086000442504883 C 0.694000244140625 5.451999664306641 0 6.395999908447266 0 7.5 C 0 8.604000091552734 0.694000244140625 9.548000335693359 1.673000335693359 9.913999557495117 C 1.243000030517578 10.86400032043457 1.414999961853027 12.02400016784668 2.196999549865723 12.80299949645996 C 2.977001190185547 13.58199977874756 4.133999824523926 13.76099967956543 5.086000442504883 13.32699966430664 C 5.451999664306641 14.30299949645996 6.395999908447266 15 7.5 15 C 8.604000091552734 15 9.548000335693359 14.30599975585938 9.913999557495117 13.32699966430664 C 10.86899948120117 13.76100063323975 12.02400016784668 13.58199977874756 12.80299949645996 12.80299949645996 C 13.58500003814697 12.02099990844727 13.75800037384033 10.86299991607666 13.32699966430664 9.913999557495117 C 14.30599975585938 9.548000335693359 15 8.604000091552734 15 7.5 C 15 6.395999908447266 14.30599975585938 5.451999664306641 13.32699966430664 5.086000442504883 C 13.75699996948242 4.13599967956543 13.58500003814697 2.979000091552734 12.80299949645996 2.196999549865723 C 12.02099990844727 1.414999961853027 10.86299896240234 1.241998672485352 9.913999557495117 1.673000335693359 C 9.548000335693359 0.694000244140625 8.604000091552734 0 7.5 0 M 6.691601753234863 10.10512828826904 C 6.608733177185059 10.10512828826904 6.525874137878418 10.07337665557861 6.463000297546387 10.01000022888184 L 4.244999885559082 7.77400016784668 C 4.119000434875488 7.64799976348877 4.119999885559082 7.443999767303467 4.246999740600586 7.317999839782715 L 5.008999824523926 6.562000274658203 C 5.135000228881836 6.436001777648926 5.33899974822998 6.437000274658203 5.465000152587891 6.562999725341797 L 6.699999809265137 7.808000087738037 L 9.548000335693359 4.982999801635742 C 9.673999786376953 4.858000755310059 9.878000259399414 4.859000205993652 10.00300025939941 4.984999656677246 L 10.76000022888184 5.748000144958496 C 10.88500022888184 5.87399959564209 10.88399982452393 6.078000068664551 10.75799942016602 6.204000473022461 L 6.918000221252441 10.01200008392334 C 6.855377197265625 10.07412624359131 6.77348518371582 10.10512828826904 6.691601753234863 10.10512828826904 M 7.5 -1.5 C 8.721233367919922 -1.5 9.860552787780762 -0.9457130432128906 10.62262725830078 -0.04198074340820312 C 10.74128532409668 -0.05227851867675781 10.86086082458496 -0.05743980407714844 10.98126983642578 -0.05743980407714844 C 12.07036018371582 -0.05735969543457031 13.09391975402832 0.3666000366210938 13.86365985870361 1.136340141296387 C 14.72578811645508 1.998468399047852 15.13909149169922 3.196074485778809 15.03917121887207 4.375005722045898 C 15.94466590881348 5.137087821960449 16.5 6.277423858642578 16.5 7.5 C 16.5 8.72226619720459 15.94491672515869 9.862360000610352 15.03982925415039 10.62444019317627 C 15.14005947113037 11.8029613494873 14.72659397125244 13.00072574615479 13.86365985870361 13.86365985870361 C 13.09346008300781 14.63385963439941 12.07005023956299 15.058030128479 10.98194980621338 15.058030128479 C 10.8612060546875 15.058030128479 10.74125480651855 15.05282497406006 10.62223625183105 15.04244518280029 C 9.860162734985352 15.9459056854248 8.721027374267578 16.5 7.5 16.5 C 6.279873847961426 16.5 5.141024589538574 15.94602870941162 4.378546714782715 15.04251003265381 C 4.259794235229492 15.05284976959229 4.140139579772949 15.058030128479 4.019619941711426 15.058030128479 C 2.931509971618652 15.058030128479 1.907779693603516 14.63409996032715 1.137029647827148 13.86435031890869 C 0.2733793258666992 13.00401782989502 -0.1405811309814453 11.80552673339844 -0.03966903686523438 10.62457466125488 C -0.9448928833007812 9.862493515014648 -1.5 8.722370147705078 -1.5 7.5 C -1.5 6.27773380279541 -0.9449167251586914 5.137640953063965 -0.03982925415039062 4.37555980682373 C -0.1400594711303711 3.197038650512695 0.2734060287475586 1.999274253845215 1.136340141296387 1.136340141296387 C 1.902190208435059 0.3675298690795898 2.926059722900391 -0.05698966979980469 4.017299652099609 -0.05698966979980469 C 4.137025833129883 -0.05698966979980469 4.256922721862793 -0.05160999298095703 4.37651538848877 -0.04096317291259766 C 5.138592720031738 -0.9453725814819336 6.278249740600586 -1.5 7.5 -1.5 Z"
          stroke="none"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export const StarFilledIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className || "w-[12px] h-[12px]"}
    viewBox="0 0 20 20"
  >
    <path
      fill="#E8B12E"
      fillRule="evenodd"
      d="M13.01 10.236l3.854-3.714a.44.44 0 0 0 .114-.456.45.45 0 0 0-.365-.302l-5.326-.766L8.906.228C8.83.076 8.665 0 8.5 0c-.165 0-.33.076-.406.228l-2.382 4.77-5.325.766a.441.441 0 1 0-.25.758l3.853 3.714-.91 5.244a.442.442 0 0 0 .301.495c.015.005.03.006.045.01a.436.436 0 0 0 .163.008c.012-.002.024-.002.036-.005a.467.467 0 0 0 .112-.04L8.5 13.474l4.763 2.476a.457.457 0 0 0 .476-.034c.14-.1.21-.268.18-.435l-.91-5.244z"
    />
  </svg>
);

export const SortIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className="w-6 h-6"
    width="10.833"
    height="20.443"
    viewBox="0 0 10.833 20.443"
  >
    <g id="Gruppe_160" data-name="Gruppe 160" transform="translate(0.351 0.701)">
      <g id="Pfeil" transform="translate(0 14.056)">
        <path
          id="Pfad_1"
          data-name="Pfad 1"
          d="M252.757-36.956l5.066,4.984,5.066-4.984"
          transform="translate(-252.757 36.956)"
          fill="none"
          stroke="var(--color-primary)"
          strokeWidth="1"
        />
      </g>
      <path
        id="Pfad_157"
        data-name="Pfad 157"
        d="M21.5,12.96V31.514"
        transform="translate(-16.434 -12.96)"
        fill="none"
        stroke="var(--color-primary)"
        strokeWidth="1"
      />
      <g id="Pfeil-2" data-name="Pfeil" transform="translate(10.131 4.984) rotate(180)">
        <path
          id="Pfad_1-2"
          data-name="Pfad 1"
          d="M252.757-36.956l5.066,4.984,5.066-4.984"
          transform="translate(-252.757 36.956)"
          fill="none"
          stroke="var(--color-primary)"
          strokeWidth="1"
        />
      </g>
    </g>
  </svg>
);

export const SearchIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className ? props.className : `w-6 h-6`}
    width="23.925"
    height="23.925"
    viewBox="0 0 23.925 23.925"
  >
    <g id="Gruppe_106" data-name="Gruppe 106" transform="translate(0.5 0.5)">
      <circle
        id="Ellipse_10"
        data-name="Ellipse 10"
        cx="8.275"
        cy="8.275"
        r="8.275"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_73"
        data-name="Pfad 73"
        d="M515.3,350.571l7.081,7.081a1.381,1.381,0,0,1,0,1.953l-.448.447a1.381,1.381,0,0,1-1.953,0l-7.08-7.081"
        transform="translate(-499.967 -337.647)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export const MapIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className="w-6 h-6"
    width="24.537"
    height="26.504"
    viewBox="0 0 24.537 26.504"
  >
    <g id="Gruppe_162" data-name="Gruppe 162" transform="translate(0.508 0.5)">
      <path
        id="Pfad_161"
        data-name="Pfad 161"
        d="M39.918,63.7H36.332a.836.836,0,0,0-.785.549L32.2,73.387a.836.836,0,0,0,.784,1.123l2.174,0,19.675.024a.836.836,0,0,0,.789-1.113l-3.22-9.165a.836.836,0,0,0-.788-.559H48.166"
        transform="translate(-32.152 -49.032)"
        fill="none"
        stroke="#464545"
        strokeWidth="1"
      />
      <path
        id="Pfad_158"
        data-name="Pfad 158"
        d="M40.664,79.115"
        transform="translate(-37.516 -58.745)"
        fill="none"
        stroke="#222221"
        strokeWidth="1"
      />
      <path
        id="Pfad_159"
        data-name="Pfad 159"
        d="M51.406,45.666a.678.678,0,0,0,1.121.013c1.718-2.405,6.707-9.6,6.707-12.754a7.224,7.224,0,0,0-7.3-7.248,6.96,6.96,0,0,0-7.067,7.108C44.919,35.855,49.741,43.214,51.406,45.666Z"
        transform="translate(-40.16 -25.677)"
        fill="none"
        stroke="var(--color-primary)"
        strokeWidth="1"
      />
      <ellipse
        id="Ellipse_46"
        data-name="Ellipse 46"
        cx="3.791"
        cy="3.791"
        rx="3.791"
        ry="3.791"
        transform="translate(7.949 2.61)"
        fill="none"
        stroke="var(--color-primary)"
        strokeWidth="1"
      />
      <path
        id="Pfad_160"
        data-name="Pfad 160"
        d="M54.748,63.7"
        transform="translate(-46.389 -49.032)"
        fill="none"
        stroke="#464545"
        strokeWidth="1"
      />
      <line
        id="Linie_16"
        data-name="Linie 16"
        x2="2.695"
        y2="10.838"
        transform="translate(17.07 14.668)"
        fill="none"
        stroke="#464545"
        strokeWidth="1"
      />
      <line
        id="Linie_17"
        data-name="Linie 17"
        x1="3.369"
        y2="10.813"
        transform="translate(3.01 14.668)"
        fill="none"
        stroke="#464545"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export const PriceComparisonIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="44.55"
    height="39.097"
    viewBox="0 0 44.55 39.097"
  >
    <g id="Gruppe_115" data-name="Gruppe 115" transform="translate(-508.785 -431.298)">
      <path
        id="Pfad_138"
        data-name="Pfad 138"
        d="M514.533,468.473"
        transform="translate(-0.947 -6.598)"
        fill="none"
        stroke="#353434"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_139"
        data-name="Pfad 139"
        d="M510.149,446.812s5.375,1.094,5.431-5.468"
        transform="translate(-0.156 -1.701)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_140"
        data-name="Pfad 140"
        d="M515.552,466.489s1.094-5.376-5.467-5.431"
        transform="translate(-0.144 -5.259)"
        fill="none"
        stroke="var(--color-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <g id="Gruppe_114" data-name="Gruppe 114" transform="translate(509.285 438.963)">
        <path
          id="Pfad_141"
          data-name="Pfad 141"
          d="M531.2,458.252a5.975,5.975,0,1,1,7.154-9.554"
          transform="translate(-512.765 -441.743)"
          fill="none"
          stroke="var(--color-primary)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Pfad_142"
          data-name="Pfad 142"
          d="M556.026,446.163a5.954,5.954,0,0,0,4.328,1.427"
          transform="translate(-517.722 -441.534)"
          fill="none"
          stroke="var(--color-primary)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Pfad_143"
          data-name="Pfad 143"
          d="M561,461.062s-5.376-1.094-5.431,5.468"
          transform="translate(-517.64 -444.211)"
          fill="none"
          stroke="var(--color-primary)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Pfad_144"
          data-name="Pfad 144"
          d="M519.048,463.624h-5.8a3.959,3.959,0,0,1-3.959-3.959V444.473a3.959,3.959,0,0,1,3.959-3.959h25"
          transform="translate(-509.285 -440.514)"
          fill="none"
          stroke="var(--color-primary)"
          strokeWidth="1"
        />
        <path
          id="Pfad_145"
          data-name="Pfad 145"
          d="M555.357,440.893a3.961,3.961,0,0,1,2.418,3.648v15.192a3.959,3.959,0,0,1-3.959,3.959H536.649"
          transform="translate(-514.224 -440.582)"
          fill="none"
          stroke="var(--color-primary)"
          strokeWidth="1"
        />
      </g>
      <path
        id="Pfad_146"
        data-name="Pfad 146"
        d="M526.109,478.869"
        transform="translate(-3.037 -8.474)"
        fill="none"
        stroke="var(--color-primary)"
        strokeWidth="1"
      />
      <path
        id="Pfad_147"
        data-name="Pfad 147"
        d="M519.552,465.328"
        transform="translate(-1.853 -6.03)"
        fill="none"
        stroke="var(--color-primary)"
        strokeWidth="1"
      />
      <path
        id="Pfad_148"
        data-name="Pfad 148"
        d="M525.657,469.324s4.633,1.36,6.863-1.765.824-6.928.824-6.928l12-15.953c.688-.015,4.512-.213,6.453-2.8,2.138-2.844,0-7.346,0-7.346l-2.4,3.194-.784,1.027a.248.248,0,0,1-.345.048l-2.544-1.895a.276.276,0,0,1-.065-.374l2.864-4.32s-4.633-1.36-6.863,1.765-.824,6.928-.824,6.928l-12,15.953c-.688.015-4.511.213-6.453,2.8-2.137,2.844,0,7.346,0,7.346l2.4-3.194.96-1.246a.219.219,0,0,1,.3-.041l2.619,1.95a.189.189,0,0,1,.044.257Z"
        transform="translate(-2.193 0)"
        fill="none"
        stroke="#353434"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export const LocationIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    id="Icon_location"
    className={props.className ?? "absolute top-2 right-2"}
    xmlns="http://www.w3.org/2000/svg"
    width="17.326"
    height="23.654"
    viewBox="0 0 17.326 23.654"
  >
    <path
      id="Pfad_120"
      data-name="Pfad 120"
      d="M9,.346A8.456,8.456,0,0,0,.3,9c0,3.334,1.146,4.375,7.111,13.942a1.7,1.7,0,0,0,3.152,0C16.534,13.37,17.629,12.333,17.629,9A8.4,8.4,0,0,0,9,.346Zm0,21.4C3.027,12.173,2.25,11.568,2.25,9a6.75,6.75,0,0,1,13.5,0C15.75,11.557,15.04,12.067,9,21.75ZM5.25,9A3.75,3.75,0,1,1,9,12.75,3.75,3.75,0,0,1,5.25,9Z"
      transform="translate(-0.303 -0.346)"
    />
  </svg>
);

export const MapLocationIcon = (props: {
  className?: string;
  color?: string;
  lat?: number;
  lng?: number;
}) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="44.713"
    height="53.615"
    viewBox="0 0 44.713 53.615"
    className={props.className}
  >
    <defs>
      <filter id="Marker" x="0" y="0" width="44.713" height="53.615" filterUnits="userSpaceOnUse">
        <feGaussianBlur stdDeviation="3" result="blur"></feGaussianBlur>
        <feFlood floodOpacity="0.161"></feFlood>
        <feComposite operator="in" in2="blur"></feComposite>
        <feComposite in="SourceGraphic"></feComposite>
      </filter>
    </defs>
    <g id="icon-location-outline-blue" transform="translate(-14.776 -135.686)">
      <g transform="matrix(1, 0, 0, 1, 14.78, 135.69)" filter="url(#Marker)">
        <path
          data-name="Pfad 167"
          d="M37.131,141.686a13.355,13.355,0,0,0-13.355,13.355c0,5.386,1.877,6.887,11.984,21.538a1.667,1.667,0,0,0,2.318.428,1.648,1.648,0,0,0,.428-.428c10.108-14.65,11.984-16.159,11.984-21.538a13.354,13.354,0,0,0-13.355-13.355h0m0,18.482a5.127,5.127,0,1,1,5.127-5.127,5.127,5.127,0,0,1-5.127,5.127"
          transform="translate(-14.78 -135.69)"
          fill="var(--color-primary)"
        />
      </g>
    </g>
  </svg>
);

export const CalendarIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width="18.731"
    height="21.905"
    viewBox="0 0 18.731 21.905"
  >
    <g id="Gruppe_184" data-name="Gruppe 184" transform="translate(1 0.5)">
      <g id="Ebene_1" data-name="Ebene 1" transform="translate(2.896 9.001)">
        <g id="Gruppe_186" data-name="Gruppe 186">
          <path
            id="Pfad_165"
            data-name="Pfad 165"
            d="M288.235,407.258h0a.26.26,0,0,0-.183.077l-5.765,5.765-2.118-2.118a.263.263,0,0,0-.372,0l-.619.62a.26.26,0,0,0-.077.183v0a.261.261,0,0,0,.077.184L282.1,414.9a.261.261,0,0,0,.182.077h.007a.263.263,0,0,0,.183-.077l6.57-6.57a.262.262,0,0,0,.077-.184v0a.262.262,0,0,0-.077-.184l-.62-.619a.26.26,0,0,0-.183-.077"
            transform="translate(-278.095 -407.258)"
            fill="var(--color-primary)"
          />
        </g>
      </g>
      <g id="LOi">
        <rect
          id="Rechteck_78"
          data-name="Rechteck 78"
          width="16.731"
          height="16.995"
          rx="1.1"
          transform="translate(0 3.409)"
          fill="none"
          stroke="var(--color-primary)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <rect
          id="Rechteck_79"
          data-name="Rechteck 79"
          width="16.488"
          height="2.344"
          transform="translate(0.219 3.721)"
          fill="var(--color-primary)"
          stroke="var(--color-primary)"
          strokeWidth="1"
        />
        <rect
          id="Rechteck_80"
          data-name="Rechteck 80"
          width="2.189"
          height="3.624"
          rx="0.4"
          transform="translate(3.149 0.014)"
          fill="var(--color-primary)"
          stroke="var(--color-primary)"
          strokeWidth="1"
        />
        <rect
          id="Rechteck_81"
          data-name="Rechteck 81"
          width="2.189"
          height="3.624"
          rx="0.4"
          transform="translate(11.361)"
          fill="var(--color-primary)"
          stroke="var(--color-primary)"
          strokeWidth="1"
        />
      </g>
    </g>
  </svg>
);

export const CogIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width="17"
    height="18"
    viewBox="0 0 17 18"
  >
    <path
      fill="var(--color-primary)"
      d="M15.431 8.077l1.123-.649c.333-.191.494-.583.394-.954-.402-1.5-1.193-2.84-2.259-3.908-.27-.27-.69-.326-1.022-.134l-1.121.648c-.364-.261-.753-.486-1.16-.671V1.112c0-.383-.259-.72-.63-.818-1.473-.392-3.037-.392-4.512 0-.371.099-.63.434-.63.818V2.41c-.407.185-.796.41-1.16.67l-1.12-.647C3 2.24 2.581 2.295 2.31 2.566 1.245 3.633.454 4.974.051 6.474c-.099.371.062.762.395.954l1.123.649c-.043.445-.043.894 0 1.34l-1.123.648c-.333.192-.494.584-.394.954.402 1.5 1.193 2.841 2.259 3.908.27.271.69.326 1.022.135l1.121-.648c.364.26.753.485 1.16.671v1.296c0 .384.259.72.63.819 1.473.391 3.037.392 4.512 0 .371-.099.63-.435.63-.819v-1.296c.407-.186.796-.41 1.16-.67l1.12.647c.333.191.752.136 1.023-.135 1.066-1.067 1.857-2.407 2.26-3.907.099-.371-.062-.763-.395-.955l-1.123-.648c.043-.446.043-.894 0-1.34zm-1.858 2.222l1.546.892c-.278.751-.682 1.45-1.194 2.065l-1.546-.893c-1.128.966-1.293 1.06-2.687 1.553V15.7c-.789.135-1.595.135-2.384 0v-1.784c-1.394-.492-1.56-.587-2.687-1.553l-1.546.893c-.512-.616-.916-1.314-1.194-2.065l1.546-.892c-.27-1.456-.27-1.647 0-3.105L1.88 6.302c.277-.748.682-1.447 1.194-2.064l1.546.893C5.75 4.164 5.914 4.07 7.308 3.578V1.793c.789-.134 1.595-.134 2.384 0v1.785c1.394.492 1.56.587 2.687 1.553l1.546-.893c.512.616.916 1.314 1.194 2.064l-1.546.892c.27 1.457.27 1.648 0 3.105zM8.5 5.361c-1.867 0-3.386 1.519-3.386 3.386 0 1.867 1.519 3.386 3.386 3.386 1.867 0 3.386-1.52 3.386-3.386 0-1.867-1.519-3.386-3.386-3.386zm0 5.079c-.934 0-1.693-.76-1.693-1.693 0-.934.76-1.693 1.693-1.693.934 0 1.693.76 1.693 1.693S9.433 10.44 8.5 10.44z"
    />
  </svg>
);

export const OutlineLocationIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width="15.5"
    height="20.5"
    viewBox="0 0 15.5 20.5"
  >
    <path
      fill={`var(--color-${props.color || "primary"})`}
      d="M7.5,18.513C2.059,10.644,1.25,10.019,1.25,7.5A6.251,6.251,0,0,1,11.92,3.08,6.212,6.212,0,0,1,13.75,7.5c0,2.52-.808,3.143-6.25,11.013M7.5,0A7.5,7.5,0,0,0,0,7.5c0,3.024,1.054,3.868,6.73,12.1a.936.936,0,0,0,1.54,0C13.947,11.368,15,10.524,15,7.5A7.5,7.5,0,0,0,7.5,0m0,10A2.5,2.5,0,1,1,10,7.5,2.5,2.5,0,0,1,7.5,10m0-6.25A3.75,3.75,0,1,0,11.25,7.5,3.754,3.754,0,0,0,7.5,3.75"
    />
  </svg>
);

export const EuroIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width="17"
    height="24"
    viewBox="0 0 17 24"
  >
    <path
      d="M16.907 22.854l-.348-1.575c-.075-.349-.429-.568-.777-.488-.552.129-1.42.29-2.395.29-3.508 0-6.267-2.117-7.403-5.218h6.937c.306 0 .568-.215.627-.515l.268-1.286c.08-.401-.22-.77-.627-.77H5.261c-.08-.863-.113-1.731-.032-2.572h8.705c.305 0 .568-.215.627-.51l.273-1.285c.086-.402-.22-.777-.627-.777H5.791c1.125-3.128 3.884-5.25 7.5-5.25.788 0 1.548.113 2.046.204.333.059.654-.14.74-.466L16.5 1.05c.096-.364-.134-.729-.504-.798C15.386.139 14.421 0 13.356 0 7.997 0 3.728 3.434 2.324 8.143H.643c-.354 0-.643.29-.643.643v1.285c0 .354.29.643.643.643H1.88c-.064.847-.053 1.902.022 2.572H.642c-.353 0-.642.289-.642.643v1.285c0 .354.29.643.643.643h1.725C3.76 20.61 7.908 24 13.35 24c1.307 0 2.432-.225 3.08-.386.343-.085.552-.423.477-.76z"
      transform="translate(-186 -455) translate(186 455)"
    />
  </svg>
);

export const RatingStars = (props: { className?: string; type: string; percent: number }) => (
  <svg
    aria-hidden="true"
    className={props.className}
    width="100"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 92.99 16"
  >
    <defs>
      <linearGradient id={`${props.percent}-${props.type}`}>
        <stop offset={`${props.percent ?? 0}%`} stopColor="#F59E0B" />
        <stop offset={`${props.percent ?? 0}%`} stopColor="#FDE68A" />
      </linearGradient>
    </defs>
    <path
      d="M17,6.07a.43.43,0,0,1-.12.45L13,10.24h0l.91,5.24a.44.44,0,0,1-.18.44.46.46,0,0,1-.48,0L8.5,13.47,3.74,16l-.12,0h0a.29.29,0,0,1-.16,0H3.38a.43.43,0,0,1-.3-.49L4,10.24.14,6.52A.5.5,0,0,1,.07,6a.41.41,0,0,1,.32-.2L5.71,5,8.09.23a.48.48,0,0,1,.82,0L11.29,5l5.32.76A.47.47,0,0,1,17,6.07Zm18.63-.31L30.29,5,27.91.23a.48.48,0,0,0-.82,0L24.71,5l-5.32.76a.41.41,0,0,0-.32.2.5.5,0,0,0,.07.56L23,10.24l-.91,5.24a.43.43,0,0,0,.3.49h.05a.29.29,0,0,0,.16,0h0l.12,0,4.76-2.48L32.26,16a.46.46,0,0,0,.48,0,.44.44,0,0,0,.18-.44L32,10.24h0l3.85-3.72A.43.43,0,0,0,36,6.07.47.47,0,0,0,35.61,5.76Zm19,0L49.29,5,46.91.23a.48.48,0,0,0-.82,0L43.71,5l-5.32.76a.41.41,0,0,0-.32.2.5.5,0,0,0,.07.56L42,10.24l-.91,5.24a.43.43,0,0,0,.3.49h0a.29.29,0,0,0,.16,0h0l.12,0,4.76-2.48L51.26,16a.46.46,0,0,0,.48,0,.44.44,0,0,0,.18-.44L51,10.24h0l3.85-3.72A.43.43,0,0,0,55,6.07.47.47,0,0,0,54.61,5.76Zm19,0L68.29,5,65.91.23a.48.48,0,0,0-.82,0L62.71,5l-5.32.76a.41.41,0,0,0-.32.2.5.5,0,0,0,.07.56L61,10.24l-.91,5.24a.43.43,0,0,0,.3.49h0a.29.29,0,0,0,.16,0h0l.12,0,4.76-2.48L70.26,16a.46.46,0,0,0,.48,0,.44.44,0,0,0,.18-.44L70,10.24h0l3.85-3.72A.43.43,0,0,0,74,6.07.47.47,0,0,0,73.61,5.76Zm19.25.76A.43.43,0,0,0,93,6.07a.47.47,0,0,0-.37-.31L87.29,5,84.91.23a.48.48,0,0,0-.82,0L81.71,5l-5.32.76a.41.41,0,0,0-.32.2.5.5,0,0,0,.07.56L80,10.24l-.91,5.24a.43.43,0,0,0,.3.49h.05a.29.29,0,0,0,.16,0h0l.12,0,4.76-2.48L89.26,16a.46.46,0,0,0,.48,0,.44.44,0,0,0,.18-.44L89,10.24h0Z"
      transform={`translate(-0.01)`}
      fill={`url(#${props.percent}-${props.type})`}
      fillOpacity="1"
      fillRule="evenodd"
    />
  </svg>
);

export const LoadingIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="var(--color-primary)"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="var(--color-primary)"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);

export const RepareoLogoIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="41"
    viewBox="0 0 38 41"
    fill="none"
  >
    <rect y="2" width="27.2" height="27.2" rx="6.48" fill="#0F1A17" />
    <rect x="10.7998" y="11" width="27.2" height="27.2" rx="6.48" fill="#7FFFC3" />
    <path
      d="M10.7998 14.6C10.7998 12.6118 12.4116 11 14.3998 11H27.1998V25.6C27.1998 27.5882 25.588 29.2 23.5998 29.2H10.7998V14.6Z"
      fill="#008346"
    />
  </svg>
);

export const RepareoOldLogoIcon = (props: { className?: string }) => (
  <svg
    aria-hidden="true"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="29"
    viewBox="0 0 19 29"
    fill="none"
  >
    <g fillRule="evenodd">
      <path
        fill="#444"
        d="M15.303 6.505l-.71-2.834c-1.614.419-2.808 1.803-2.97 1.996v8.984l3.422 1.095v2.318H3.749v-2.286l3.066-1.095V4.443L3.297 3.285V.42h7.552l.194 2.544C11.753 1.996 13.915 0 16.884 0c.872 0 1.743.097 2.066.161v6.344h-3.647z"
      />
      <path fill="#2688D9" d="M11.774 28.326v-4.903l6.728-1.095v-2.153H0v2.185l6.968 1.095v4.87z" />
    </g>
  </svg>
);

export const OutlinedStarIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    width="13.722"
    height="12.957"
    viewBox="0 0 13.722 12.957"
  >
    <path
      id="icon-star-filled"
      d="M9.283,7.32l2.756-2.656a.315.315,0,0,0,.082-.326.322.322,0,0,0-.261-.216L8.05,3.574,6.348.163a.34.34,0,0,0-.581,0l-1.7,3.411L.255,4.122c-.211.031-.28.1-.32.216s.038.188.142.326L2.832,7.32l-.651,3.75a.316.316,0,0,0,.215.354c.011,0,.021,0,.032.007a.312.312,0,0,0,.117.006l.026,0a.334.334,0,0,0,.08-.029L6.057,9.636l3.406,1.771a.327.327,0,0,0,.34-.024.314.314,0,0,0,.129-.311l-.651-3.75Z"
      transform="translate(0.825 0.75)"
      fill="none"
      stroke="#fff"
      strokeWidth="1.5"
    />
  </svg>
);

export const OutlinedCalendarIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="11.339"
    viewBox="0 0 13 11.339"
  >
    <g id="Gruppe_735" data-name="Gruppe 735" transform="translate(-470.322 -257.448)">
      <rect
        id="Rechteck_21"
        data-name="Rechteck 21"
        width="1.432"
        height="3.48"
        rx="0.716"
        transform="translate(473.257 257.448)"
        fill="#fff"
      />
      <rect
        id="Rechteck_22"
        data-name="Rechteck 22"
        width="1.432"
        height="3.48"
        rx="0.716"
        transform="translate(478.956 257.448)"
        fill="#fff"
      />
      <line
        id="Linie_1"
        data-name="Linie 1"
        x2="10.388"
        transform="translate(471.434 262.766)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <g
        id="Rechteck_301"
        data-name="Rechteck 301"
        transform="translate(470.322 258.787)"
        fill="none"
        stroke="#fff"
        strokeWidth="1.5"
      >
        <rect width="13" height="10" rx="2" stroke="none" />
        <rect x="0.75" y="0.75" width="11.5" height="8.5" rx="1.25" fill="none" />
      </g>
    </g>
  </svg>
);

export const CalendarLightIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    className={props.className}
    fill={`var(--color-${props.color})`}
  >
    <path d="M112 0C120.8 0 128 7.164 128 16V64H320V16C320 7.164 327.2 0 336 0C344.8 0 352 7.164 352 16V64H384C419.3 64 448 92.65 448 128V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V128C0 92.65 28.65 64 64 64H96V16C96 7.164 103.2 0 112 0zM416 192H32V448C32 465.7 46.33 480 64 480H384C401.7 480 416 465.7 416 448V192zM384 96H64C46.33 96 32 110.3 32 128V160H416V128C416 110.3 401.7 96 384 96z" />
  </svg>
);

export const CarOutlineGrey = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="14"
    viewBox="0 0 18 14"
    className={props.className}
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#777" fillRule="nonzero">
        <g>
          <path
            d="M17.578 4.667h-1.836l-1.102-2.84C14.212.724 13.179 0 12.03 0H5.97c-1.148 0-2.18.723-2.61 1.827l-1.102 2.84H.422c-.274 0-.476.267-.409.543l.21.875c.048.195.217.332.41.332h.398C.74 6.933.563 7.525.563 8.167v4.958c0 .483.377.875.843.875h.563c.466 0 .843-.392.843-.875v-.875h12.376v.875c0 .483.377.875.843.875h.563c.466 0 .843-.392.843-.875V8.167c0-.642-.177-1.234-.467-1.75h.397c.194 0 .363-.137.41-.331l.21-.875c.067-.277-.135-.544-.41-.544zM4.925 2.481c.173-.444.582-.731 1.044-.731h6.062c.462 0 .871.287 1.044.731l.848 2.185H4.077l.848-2.185zM15.75 9.917c0 .321-.252.583-.563.583H2.813c-.31 0-.563-.262-.563-.583v-1.75c0-.965.757-1.75 1.688-1.75h10.124c.931 0 1.688.785 1.688 1.75v1.75zM4.5 7.29c-.675 0-1.125.466-1.125 1.164s.45 1.163 1.125 1.163 1.688.116 1.688-.582S5.175 7.291 4.5 7.291zm9 0c-.675 0-1.688 1.047-1.688 1.745 0 .698 1.013.582 1.688.582s1.125-.465 1.125-1.163-.45-1.164-1.125-1.164z"
            transform="translate(-71.000000, -621.000000) translate(71.000000, 621.000000)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const LabourStepsIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="23.084"
    height="19.883"
    viewBox="0 0 23.084 19.883"
    className={props.className}
  >
    <g id="Gruppe_122" data-name="Gruppe 122" transform="translate(-20.65 -261.653)">
      <path
        id="Pfad_92"
        data-name="Pfad 92"
        d="M24.121,23.691c-2.745,0-4.979-2.675-4.979-5.964v-.739a.379.379,0,1,1,.758,0v.739c0,2.817,1.933,5.2,4.22,5.2s4.22-2.379,4.22-5.194v-.724a.379.379,0,1,1,.759,0v.724c0,3.286-2.234,5.96-4.979,5.96"
        transform="translate(8.106 250.881)"
        fill="var(--color-primary)"
        stroke="var(--color-primary)"
        strokeWidth="0.7"
      />
      <path
        id="Pfad_93"
        data-name="Pfad 93"
        d="M1.6,43.739a.381.381,0,0,1-.379-.383c0-.6.4-2.678.431-3.056l.017-.184,6.593-3.291.218.224a5.542,5.542,0,0,0,7.934,0l.218-.223,6.593,3.291.017.184c.035.379.363,2.891.363,3.491a.379.379,0,1,1-.758,0c0-.457-.095-.539-.343-3.236L16.73,37.8a6.3,6.3,0,0,1-8.566,0L2.39,40.554a21.7,21.7,0,0,1-.411,2.8.381.381,0,0,1-.379.383"
        transform="translate(19.779 237.013)"
        fill="var(--color-primary)"
        stroke="var(--color-primary)"
        strokeWidth="0.7"
      />
      <g id="Gruppe_63" data-name="Gruppe 63" transform="translate(27.248 262.003)">
        <path
          id="Pfad_95"
          data-name="Pfad 95"
          d="M4.979,7.6a5.779,5.779,0,0,1,2.138.519,1.392,1.392,0,0,0,1.656-.411A1.946,1.946,0,0,0,9.2,6.494V5.77A4.366,4.366,0,0,0,7.96,2.665,4.235,4.235,0,0,0,2,2.665,4.363,4.363,0,0,0,.76,5.771v.124c.612.044,2.116.124,4.4.066h.009a.383.383,0,0,1,.009.766c-2.158.054-3.7-.015-4.413-.064a2.023,2.023,0,0,0,.42,1.05,1.394,1.394,0,0,0,1.656.411A5.793,5.793,0,0,1,4.977,7.6h0Zm2.7,1.4a2.186,2.186,0,0,1-.862-.178,5.042,5.042,0,0,0-1.842-.458,5.052,5.052,0,0,0-1.843.458A2.148,2.148,0,0,1,.586,8.185,2.748,2.748,0,0,1,0,6.456V5.771A5.141,5.141,0,0,1,1.468,2.117a4.989,4.989,0,0,1,7.022,0A5.141,5.141,0,0,1,9.957,5.771l0,.685A2.749,2.749,0,0,1,9.37,8.185a2.131,2.131,0,0,1-1.688.822Z"
          transform="translate(0.001 -0.672)"
          fill="var(--color-primary)"
          stroke="var(--color-primary)"
          strokeWidth="0.7"
        />
      </g>
    </g>
  </svg>
);

export const EngineIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={"h-10 w-10"}
    viewBox="0 0 640 512"
  >
    <path d="M320 256C320 273.7 305.7 288 288 288C270.3 288 256 273.7 256 256C256 238.3 270.3 224 288 224C305.7 224 320 238.3 320 256zM288 272C296.8 272 304 264.8 304 256C304 247.2 296.8 240 288 240C279.2 240 272 247.2 272 256C272 264.8 279.2 272 288 272zM352 256C352 238.3 366.3 224 384 224C401.7 224 416 238.3 416 256C416 273.7 401.7 288 384 288C366.3 288 352 273.7 352 256zM384 240C375.2 240 368 247.2 368 256C368 264.8 375.2 272 384 272C392.8 272 400 264.8 400 256C400 247.2 392.8 240 384 240zM224 256C224 273.7 209.7 288 192 288C174.3 288 160 273.7 160 256C160 238.3 174.3 224 192 224C209.7 224 224 238.3 224 256zM192 272C200.8 272 208 264.8 208 256C208 247.2 200.8 240 192 240C183.2 240 176 247.2 176 256C176 264.8 183.2 272 192 272zM416 72C416 76.42 412.4 80 408 80H312V128H396.6C409.3 128 421.6 131.7 432.1 138.7L483.5 173C501.3 184.9 512 204.9 512 226.3V384C512 419.3 483.3 448 448 448H279.2C264.2 448 249.7 442.8 238.2 433.2L179.2 384H112C85.49 384 64 362.5 64 336V264H16V344C16 348.4 12.42 352 8 352C3.582 352 0 348.4 0 344V168C0 163.6 3.582 160 8 160C12.42 160 16 163.6 16 168V248H64V176C64 149.5 85.49 128 112 128H296V80H200C195.6 80 192 76.42 192 72C192 67.58 195.6 64 200 64H408C412.4 64 416 67.58 416 72zM80 336C80 353.7 94.33 368 112 368H184.1L248.4 420.9C257.1 428.1 267.9 432 279.2 432H448C474.5 432 496 410.5 496 384V226.3C496 210.2 487.1 195.2 474.6 186.3L423.2 152.1C415.4 146.8 406.1 144 396.6 144H112C94.33 144 80 158.3 80 176V336zM544 224C544 206.3 558.3 192 576 192H608C625.7 192 640 206.3 640 224V416C640 433.7 625.7 448 608 448H576C558.3 448 544 433.7 544 416V224zM560 224V416C560 424.8 567.2 432 576 432H608C616.8 432 624 424.8 624 416V224C624 215.2 616.8 208 608 208H576C567.2 208 560 215.2 560 224z" />
  </svg>
);

export const BevEngineIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fak"
    data-icon="thin-engine-circle-bolt"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    className={"h-8 w-10"}
  >
    <path
      fill="currentColor"
      d="M320 256c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm-32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm64-16c0-17.7 14.3-32 32-32c3.1 0 6.1 .4 9 1.3c-15.3 11-28.7 24.5-39.7 39.7c-.8-2.9-1.3-5.9-1.3-9zm-128 0c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm-32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zM416 72c0 4.4-3.6 8-8 8c-32 0-64 0-96 0c0 16 0 32 0 48c28.2 0 56.4 0 84.6 0c12.7 0 25 3.7 35.5 10.7c17.1 11.4 34.3 22.9 51.4 34.3c7.6 5.1 13.9 11.6 18.6 19.1c-2-.1-4.1-.1-6.1-.1c-4.8 0-9.5 .2-14.2 .6c-2.2-2.3-4.7-4.4-7.2-6.3c-17.1-11.4-34.3-22.8-51.4-34.2c-7.8-5.3-17.1-8.1-26.6-8.1c-94.9 0-189.7 0-284.6 0c-17.7 0-32 14.3-32 32c0 53.3 0 106.7 0 160c0 17.7 14.3 32 32 32c24 0 48.1 0 72.1 0c21.4 17.6 42.9 35.3 64.3 52.9c8.7 7.2 19.5 11.1 30.8 11.1c17.6 0 35.2 0 52.8 0c2.1 5.5 4.5 10.8 7.2 16c-20 0-40 0-60 0c-15 0-29.5-5.2-41-14.8c-19.7-16.4-39.3-32.8-59-49.2c-22.4 0-44.8 0-67.2 0c-26.5 0-48-21.5-48-48c0-24 0-48 0-72c-16 0-32 0-48 0c0 26.7 0 53.3 0 80c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-58.7 0-117.3 0-176c0-4.4 3.6-8 8-8s8 3.6 8 8c0 26.7 0 53.3 0 80c16 0 32 0 48 0c0-24 0-48 0-72c0-26.5 21.5-48 48-48c61.3 0 122.7 0 184 0c0-16 0-32 0-48c-32 0-64 0-96 0c-4.4 0-8-3.6-8-8s3.6-8 8-8c69.3 0 138.7 0 208 0c4.4 0 8 3.6 8 8zM576 192l32 0c17.7 0 32 14.3 32 32c0 14.3 0 28.5 0 42.8c-4.9-6.9-10.2-13.4-16-19.6c0-7.7 0-15.5 0-23.2c0-8.8-7.2-16-16-16c-10.7 0-21.3 0-32 0c-1.7 0-3.4 .3-5 .8c-5.8-2.7-11.7-5.2-17.8-7.3c5.8-5.9 13.9-9.5 22.8-9.5zM517.8 344l58.2 0c3.3 0 6.3 2.1 7.5 5.2s.2 6.7-2.3 8.9c-37.3 32-74.7 64-112 96c-2.7 2.3-6.7 2.6-9.7 .6s-4.3-5.8-3.1-9.2c5.9-17.8 11.9-35.6 17.8-53.5c-19.4 0-38.8 0-58.2 0c-3.3 0-6.3-2.1-7.5-5.2s-.2-6.7 2.3-8.9c37.3-32 74.7-64 112-96c2.7-2.3 6.7-2.6 9.7-.6s4.3 5.8 3.1 9.2c-5.9 17.8-11.9 35.6-17.8 53.5zm-25.9 35.3c1.5 2.1 1.9 4.8 1.1 7.2c-4.1 12.2-8.1 24.4-12.2 36.6c24.6-21 49.1-42.1 73.7-63.1c-15.9 0-31.8 0-47.7 0c-2.6 0-5-1.2-6.5-3.3s-1.9-4.8-1.1-7.2c4.1-12.2 8.1-24.4 12.2-36.6c-24.6 21-49.1 42.1-73.7 63.1c15.9 0 31.8 0 47.7 0c2.6 0 5 1.2 6.5 3.3zM640 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM496 240c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128z"
      className=""
    ></path>
  </svg>
);

export const CarTypeIcon = (props: { className?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className ?? "h-8 w-10"}
    viewBox="0 0 640 512"
  >
    <path d="M480 480C432.4 480 392.9 445.4 385.3 400H254.7C247.1 445.4 207.6 480 160 480C112.4 480 72.94 445.4 65.33 400H32C14.33 400 0 385.7 0 368V256C0 222.5 25.72 195 58.49 192.2L104.5 77.26C115.4 49.92 141.9 32 171.3 32H353.2C375.1 32 395.8 41.94 409.5 59.02L515.9 192.1C584.8 194.1 640 250.6 640 320V368C640 385.7 625.7 400 608 400H574.7C567.1 445.4 527.6 480 480 480L480 480zM171.3 48C148.4 48 127.8 61.94 119.3 83.2L75.82 192H240V48H171.3zM64 208C37.49 208 16 229.5 16 256V368C16 376.8 23.16 384 32 384H64C64 330.1 106.1 288 160 288C213 288 256 330.1 256 384H384C384 330.1 426.1 288 480 288C533 288 576 330.1 576 384H608C616.8 384 624 376.8 624 368V320C624 258.1 573.9 208 512 208H64zM396.1 69.02C386.3 55.73 370.3 48 353.2 48H256V192H495.4L396.1 69.02zM160 464C204.2 464 240 428.2 240 384C240 339.8 204.2 304 160 304C115.8 304 80 339.8 80 384C80 428.2 115.8 464 160 464zM480 304C435.8 304 400 339.8 400 384C400 428.2 435.8 464 480 464C524.2 464 560 428.2 560 384C560 339.8 524.2 304 480 304z" />
  </svg>
);

export const CommercialVehicleTypeIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={"h-10 w-10"}
    viewBox="0 0 640 512"
  >
    <path d="M64.36 416H64C28.65 416 0 387.3 0 352V64C0 28.65 28.65 0 64 0H352C387.3 0 416 28.65 416 64V96H474.7C485.4 96 495.5 100.2 503 107.7L596.3 200.1C603.8 208.5 608 218.6 608 229.3V400H632C636.4 400 640 403.6 640 408C640 412.4 636.4 416 632 416H575.6C575.9 418.6 576 421.3 576 424C576 472.6 536.6 512 488 512C439.4 512 400 472.6 400 424C400 421.3 400.1 418.6 400.4 416H239.6C239.9 418.6 240 421.3 240 424C240 472.6 200.6 512 152 512C103.4 512 64 472.6 64 424C64 421.3 64.12 418.6 64.36 416H64.36zM16 64V352C16 378.5 37.49 400 64 400H67.31C77.76 363.1 111.7 336 152 336C192.3 336 226.2 363.1 236.7 400H400V64C400 37.49 378.5 16 352 16H64C37.49 16 16 37.49 16 64zM588 216C587.1 214.7 586.1 213.4 584.1 212.3L491.7 119C487.2 114.5 481.1 112 474.7 112H416V216H588zM416 232V373.4C431.9 350.8 458.2 336 488 336C528.3 336 562.2 363.1 572.7 400H592V232H416zM152 352C112.2 352 80 384.2 80 424C80 463.8 112.2 496 152 496C191.8 496 224 463.8 224 424C224 384.2 191.8 352 152 352zM488 496C527.8 496 560 463.8 560 424C560 384.2 527.8 352 488 352C448.2 352 416 384.2 416 424C416 463.8 448.2 496 488 496z" />
  </svg>
);

export const VehicleDeliveryIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={"h-10 w-10"}
    viewBox="0 0 640 512"
    fill="var(--color-primary)"
  >
    <path d="M272 16H48C30.33 16 16 30.33 16 48V432C16 449.7 30.33 464 48 464H224V480H48C21.49 480 0 458.5 0 432V48C0 21.49 21.49 0 48 0H272C298.5 0 320 21.49 320 48V165.2C314.1 170 308.7 175.5 304 181.6V48C304 30.33 289.7 16 272 16zM232 288C239.2 288 245.7 291.2 250.1 296.2C246.3 300.7 242.9 305.5 239.9 310.5C239.2 306.8 235.9 304 232 304H200C195.6 304 192 307.6 192 312V344C192 348.4 195.6 352 200 352H225.1C224.4 357.2 224 362.6 224 368H200C186.7 368 176 357.3 176 344V312C176 298.7 186.7 288 200 288H232zM64 200C64 186.7 74.75 176 88 176H120C133.3 176 144 186.7 144 200V232C144 245.3 133.3 256 120 256H88C74.75 256 64 245.3 64 232V200zM88 192C83.58 192 80 195.6 80 200V232C80 236.4 83.58 240 88 240H120C124.4 240 128 236.4 128 232V200C128 195.6 124.4 192 120 192H88zM232 176C245.3 176 256 186.7 256 200V232C256 245.3 245.3 256 232 256H200C186.7 256 176 245.3 176 232V200C176 186.7 186.7 176 200 176H232zM192 232C192 236.4 195.6 240 200 240H232C236.4 240 240 236.4 240 232V200C240 195.6 236.4 192 232 192H200C195.6 192 192 195.6 192 200V232zM64 88C64 74.75 74.75 64 88 64H120C133.3 64 144 74.75 144 88V120C144 133.3 133.3 144 120 144H88C74.75 144 64 133.3 64 120V88zM88 80C83.58 80 80 83.58 80 88V120C80 124.4 83.58 128 88 128H120C124.4 128 128 124.4 128 120V88C128 83.58 124.4 80 120 80H88zM232 64C245.3 64 256 74.75 256 88V120C256 133.3 245.3 144 232 144H200C186.7 144 176 133.3 176 120V88C176 74.75 186.7 64 200 64H232zM192 120C192 124.4 195.6 128 200 128H232C236.4 128 240 124.4 240 120V88C240 83.58 236.4 80 232 80H200C195.6 80 192 83.58 192 88V120zM64 312C64 298.7 74.75 288 88 288H120C133.3 288 144 298.7 144 312V344C144 357.3 133.3 368 120 368H88C74.75 368 64 357.3 64 344V312zM88 304C83.58 304 80 307.6 80 312V344C80 348.4 83.58 352 88 352H120C124.4 352 128 348.4 128 344V312C128 307.6 124.4 304 120 304H88zM368 368C368 385.7 353.7 400 336 400C318.3 400 304 385.7 304 368C304 350.3 318.3 336 336 336C353.7 336 368 350.3 368 368zM336 384C344.8 384 352 376.8 352 368C352 359.2 344.8 352 336 352C327.2 352 320 359.2 320 368C320 376.8 327.2 384 336 384zM528 368C528 350.3 542.3 336 560 336C577.7 336 592 350.3 592 368C592 385.7 577.7 400 560 400C542.3 400 528 385.7 528 368zM560 352C551.2 352 544 359.2 544 368C544 376.8 551.2 384 560 384C568.8 384 576 376.8 576 368C576 359.2 568.8 352 560 352zM326.4 216.6C333.2 192.6 355.2 176 380.2 176H515.8C540.8 176 562.8 192.6 569.6 216.6L591.7 293.8L590.7 294.1C619.6 306.1 640 334.7 640 368V504C640 508.4 636.4 512 632 512C627.6 512 624 508.4 624 504V448H272V504C272 508.4 268.4 512 264 512C259.6 512 256 508.4 256 504V368C256 334.7 276.4 306.1 305.3 294.1L304.3 293.8L326.4 216.6zM380.2 192C362.3 192 346.7 203.8 341.7 221L322.3 289.2C326.7 288.4 331.3 288 336 288H560C564.7 288 569.3 288.4 573.7 289.2L554.3 221C549.3 203.8 533.7 192 515.8 192H380.2zM624 368C624 332.7 595.3 304 560 304H336C300.7 304 272 332.7 272 368V432H624V368z" />
  </svg>
);

export const CircleQuestionIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    viewBox="0 0 512 512"
  >
    <path
      fill="var(--color-primary)"
      d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-123.5 0-224-100.5-224-224s100.5-224 224-224s224 100.5 224 224S379.5 480 256 480zM240 344c-13.25 0-24 10.75-24 24s10.75 24 24 24s24-10.75 24-24S253.3 344 240 344zM285.6 128H226.4C189.8 128 160 157.8 160 194.4V204c0 8.844 7.156 16 16 16S192 212.8 192 204V194.4C192 175.4 207.4 160 226.4 160h59.25C304.6 160 320 175.4 320 194.4c0 12.48-6.781 24-17.06 29.72L242.5 254.3C231.1 260.7 224 272.7 224 285.8V304C224 312.8 231.2 320 240 320S256 312.8 256 304V285.8c0-1.453 .7813-2.797 1.438-3.172l60.41-30.22C338.9 240.7 352 218.5 352 194.4C352 157.8 322.2 128 285.6 128z"
    />
  </svg>
);

export const CircleExclamationIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill={`var(--color-${props.color || "neutral-500"})`}
    viewBox="0 0 448 512"
    className={props.className}
  >
    <path d="M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z" />
  </svg>
);

export const SelectIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill={`var(--color-${props.color || "primary"})`}
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path d="M4 0C4.26522 5.96046e-08 4.51957 0.105357 4.70711 0.292893L7.70711 3.29289C8.09763 3.68342 8.09763 4.31658 7.70711 4.70711C7.31658 5.09763 6.68342 5.09763 6.29289 4.70711L4 2.41421L1.70711 4.70711C1.31658 5.09763 0.683417 5.09763 0.292893 4.70711C-0.0976311 4.31658 -0.097631 3.68342 0.292893 3.29289L3.29289 0.292893C3.48043 0.105357 3.73478 0 4 0ZM0.292893 9.29289C0.683417 8.90237 1.31658 8.90237 1.70711 9.29289L4 11.5858L6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289C8.09763 9.68342 8.09763 10.3166 7.70711 10.7071L4.70711 13.7071C4.31658 14.0976 3.68342 14.0976 3.29289 13.7071L0.292893 10.7071C-0.0976311 10.3166 -0.0976311 9.68342 0.292893 9.29289Z" />
  </svg>
);

export const ChevronLeftIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill={`var(--color-${props.color || "primary"})`}
    viewBox="0 0 320 512"
    className={props.className}
  >
    <path d="M206.7 464.6l-183.1-191.1C18.22 267.1 16 261.1 16 256s2.219-11.97 6.688-16.59l183.1-191.1c9.152-9.594 24.34-9.906 33.9-.7187c9.625 9.125 9.938 24.37 .7187 33.91L73.24 256l168 175.4c9.219 9.5 8.906 24.78-.7187 33.91C231 474.5 215.8 474.2 206.7 464.6z" />
  </svg>
);

export const PaperPlaneIcon = (props: { className?: string; color?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill={`var(--color-${props.color || "primary"})`}
    viewBox="0 0 448 512"
    className={props.className}
  >
    <path d="M511.6 36.9c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256C5.5 266.3-.7 277.8 .1 290s8.4 22.9 19.6 27.6L160 376v93c0 23.8 19.3 43 43 43c13.1 0 25.4-5.9 33.6-16.1l52.8-66 .1 0 114.2 47.6c9.1 3.8 19.4 3.2 28-1.6s14.5-13.3 16-23l64-416zm-253 380.2l-47 58.8c-2.1 2.6-5.3 4.1-8.6 4.1c-6.1 0-11-4.9-11-11V389.3l66.6 27.8zm43.1-16.7l-96.6-40.3L474.1 70.5 416 448 301.8 400.4zM450.5 48.8L173.6 347 32 288 450.5 48.8z" />
  </svg>
);

export const MapLocationIconOutline = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="12.326"
    height="23.654"
    viewBox="0 0 384 512"
  >
    <path
      fill="var(--color-primary)"
      d="M272 192C272 236.2 236.2 272 192 272C147.8 272 112 236.2 112 192C112 147.8 147.8 112 192 112C236.2 112 272 147.8 272 192zM192 240C218.5 240 240 218.5 240 192C240 165.5 218.5 144 192 144C165.5 144 144 165.5 144 192C144 218.5 165.5 240 192 240zM384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192H384zM192 32C103.6 32 32 103.6 32 192C32 207.6 37.43 229 48.56 255.4C59.47 281.3 74.8 309.4 92.14 337.5C126.2 392.8 166.6 445.7 192 477.6C217.4 445.7 257.8 392.8 291.9 337.5C309.2 309.4 324.5 281.3 335.4 255.4C346.6 229 352 207.6 352 192C352 103.6 280.4 32 192 32z"
    />
  </svg>
);

export const PhoneIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M15.125 10.4375C15.75 10.7188 16.0938 11.4062 15.9375 12.0625L15.2812 15C15.125 15.6562 14.5625 16.0938 13.875 16.0938C6.21875 16.0938 0 9.875 0 2.21875C0 1.53125 0.4375 0.96875 1.09375 0.84375L4.03125 0.15625C4.6875 0 5.375 0.34375 5.65625 0.96875L7 4.15625C7.25 4.71875 7.09375 5.40625 6.625 5.8125L5.34375 6.84375C6.25 8.46875 7.625 9.84375 9.25 10.75L10.3125 9.5C10.6875 9 11.375 8.84375 11.9375 9.0625L15.125 10.4375ZM14.2812 14.7812L14.9688 11.8438C15.0312 11.625 14.9062 11.4375 14.7188 11.3438L11.5625 10C11.375 9.9375 11.1875 9.96875 11.0625 10.125L9.78125 11.6875C9.625 11.875 9.375 11.9375 9.1875 11.8125C7.0625 10.7812 5.3125 9.03125 4.28125 6.9375C4.15625 6.71875 4.21875 6.46875 4.40625 6.3125L5.96875 5.03125C6.125 4.90625 6.15625 4.71875 6.09375 4.53125L4.75 1.375C4.65625 1.21875 4.5 1.09375 4.34375 1.09375C4.3125 1.09375 4.28125 1.125 4.25 1.125L1.3125 1.8125C1.125 1.84375 1 2 1 2.21875C1 9.3125 6.78125 15.125 13.875 15.125C14.0938 15.125 14.25 14.9688 14.2812 14.7812Z"
      fill="var(--color-primary)"
    />
  </svg>
);

export const WayBetweenLocationsIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="12.326"
    height="23.654"
    viewBox="0 0 512 512"
  >
    <path
      fill="var(--color-primary)"
      d="M440 96C440 109.3 429.3 120 416 120C402.7 120 392 109.3 392 96C392 82.75 402.7 72 416 72C429.3 72 440 82.75 440 96zM416 256H336C309.5 256 288 277.5 288 304C288 330.5 309.5 352 336 352H432C476.2 352 512 387.8 512 432C512 476.2 476.2 512 432 512H139.6C147.3 503.2 156.5 492.3 165.1 480H432C458.5 480 480 458.5 480 432C480 405.5 458.5 384 432 384H336C291.8 384 255.1 348.2 255.1 304C255.1 259.8 291.8 224 336 224H387.1C358.8 190.3 320 136.7 320 96C320 42.98 362.1 0 416 0C469 0 512 42.98 512 96C512 140.3 466 199.9 437.7 232.4C425.1 246.9 416 256 416 256zM468.4 133.7C476.5 117.5 480 104.7 480 96C480 60.65 451.3 32 416 32C380.7 32 352 60.65 352 96C352 104.7 355.5 117.5 363.6 133.7C371.5 149.4 382.2 165.7 393.6 180.8C401.3 191.1 409.1 200.6 416 208.6C422.9 200.6 430.7 191.1 438.4 180.8C449.8 165.7 460.5 149.4 468.4 133.7zM71.1 352C71.1 338.7 82.74 328 95.1 328C109.3 328 119.1 338.7 119.1 352C119.1 365.3 109.3 376 95.1 376C82.74 376 71.1 365.3 71.1 352zM117.7 488.4C115.7 490.7 113.8 492.8 112.1 494.8L112 494.8C102.5 505.5 96 512 96 512C96 512 86.9 502.9 74.3 488.4C45.98 455.9 0 396.3 0 352C0 298.1 42.98 256 96 256C149 256 192 298.1 192 352C192 392.8 152.9 446.7 124.6 480.4C122.2 483.2 119.9 485.9 117.7 488.4L117.7 488.4zM148.4 389.7C156.5 373.5 159.1 360.7 159.1 352C159.1 316.7 131.3 288 95.1 288C60.65 288 31.1 316.7 31.1 352C31.1 360.7 35.53 373.5 43.62 389.7C51.46 405.4 62.25 421.7 73.6 436.8C81.34 447.1 89.11 456.6 95.1 464.6C102.9 456.6 110.7 447.1 118.4 436.8C129.7 421.7 140.5 405.4 148.4 389.7z"
    />
  </svg>
);

export const HandHoldingCarIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 32"
    width="1em"
    height="1em"
  >
    <path
      fill="currentColor"
      d="M40 25c0 .563-.5 1-1 1h-3a3.05 3.05 0 01-2.875-2h-1.938c-.125.313-.25.563-.437.813l-.563.75c-.875 1.062-2.375 1.312-3.562.75l-1.313 1.562c-1.125 1.313-3.125 1.563-4.5.438L20.438 28a4.442 4.442 0 01-2.5 1h-.5a4.926 4.926 0 01-3.062-1.063L9.312 24h-2.5C6.375 25.188 5.25 26 4 26H2c-.563 0-1-.438-1-1 0-.5.438-1 1-1h2c.5 0 1-.438 1-1V10H1c-.563 0-1-.438-1-1 0-.5.438-1 1-1h7.125c2.125-2.063 4.813-3.438 7.688-3.813.562-.125 1.062.313 1.124.813a.914.914 0 01-.812 1.125c-2.563.375-5 1.688-6.813 3.563L9 10H7v12h3l5.625 4.375a2.8 2.8 0 002.063.625 2.669 2.669 0 001.875-1l.687-.688.813.563 1.062.875c.438.438 1.25.375 1.625-.188l2.5-3.062 1.125.938c.375.312.938.25 1.25-.188l.563-.688a.891.891 0 00-.125-1.25l-6.75-5.5c-.438-.375-.5-1-.188-1.437.375-.375 1-.5 1.438-.125l6.75 5.5c.437.375.687.813.875 1.25H33V10h-2.063l-.312-.25C28.375 7.375 25.25 6 22.187 6h-.5c-.25 0-.437.125-.625.25l-5.812 5.5c-.625.563-.563 1.5-.063 2 .126.125.5.438 1 .438.313 0 .625-.126.875-.376l.063.063c.5-.563 1.75-1.75 4.75-4.5.375-.375 1-.313 1.375.063.375.437.375 1.062-.063 1.437l-4.75 4.438c-.625.562-1.375.874-2.187.874h-.188c-1.062-.062-1.937-.625-2.375-1.125-1.25-1.374-1.187-3.374.126-4.687v-.063l5.874-5.5c.563-.5 1.25-.812 2-.812h.5c3.5 0 6.938 1.5 9.563 4H39c.5 0 1 .5 1 1 0 .563-.5 1-1 1h-4v13c0 .563.438 1.063.938 1.063L39 24c.5 0 1 .5 1 1z"
    />
  </svg>
);

export const CertificateCheckIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 33 32"
    width="1em"
    height="1em"
  >
    <path
      fill="currentColor"
      d="M15.354 20.75c-.375.375-1.062.375-1.437 0l-3.5-3.5c-.375-.375-.375-1.063 0-1.438.375-.374 1.062-.374 1.437 0l2.813 2.813 6.25-6.313c.375-.374 1.062-.374 1.437 0 .375.376.375 1.063 0 1.438l-7 7zm6.75-17.875c2.063-.375 4.25.25 5.875 1.813 1.563 1.625 2.188 3.812 1.813 5.875 1.687 1.187 2.875 3.187 2.875 5.437 0 2.313-1.188 4.25-2.875 5.5a6.557 6.557 0 01-1.813 5.813c-1.625 1.625-3.812 2.25-5.875 1.875A6.657 6.657 0 0116.667 32c-2.313 0-4.313-1.125-5.5-2.813-2.063.375-4.25-.25-5.875-1.875A6.557 6.557 0 013.479 21.5C1.792 20.25.667 18.312.667 16a6.66 6.66 0 012.812-5.438c-.375-2.062.25-4.25 1.813-5.874C6.917 3.125 9.104 2.5 11.167 2.875 12.354 1.187 14.354 0 16.604 0c2.313 0 4.313 1.188 5.5 2.875zM12.167 5.25L11.354 5A4.588 4.588 0 006.73 6.125a4.588 4.588 0 00-1.125 4.625l.25.813-.75.374c-1.5.75-2.437 2.313-2.437 4.063 0 1.813.937 3.313 2.437 4.125l.75.375-.25.813a4.588 4.588 0 001.125 4.625 4.588 4.588 0 004.625 1.125l.813-.25.375.75c.812 1.5 2.312 2.437 4.125 2.437 1.75 0 3.25-.938 4.062-2.438l.375-.75.813.25c1.562.5 3.375.125 4.625-1.125a4.588 4.588 0 001.125-4.625l-.25-.812.75-.375c1.5-.813 2.5-2.313 2.5-4.125 0-1.75-1-3.313-2.5-4.063l-.75-.374.25-.813a4.588 4.588 0 00-1.125-4.625A4.588 4.588 0 0021.917 5l-.813.25-.375-.75C19.917 3 18.417 2 16.667 2c-1.813 0-3.313 1-4.125 2.5l-.375.75z"
    />
  </svg>
);

export const FileRatingIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 37 32"
    width="1em"
    height="1em"
  >
    <path
      fill="currentColor"
      d="M20.333 2h-16c-1.125 0-2 .938-2 2v24c0 1.125.875 2 2 2h14.5c.563.75 1.313 1.438 2.063 2H4.333c-2.25 0-4-1.75-4-4V4c0-2.188 1.75-4 4-4h16c2.188 0 4 1.813 4 4v8.438a7.076 7.076 0 00-2 .812V4c0-1.063-.937-2-2-2zm-16 7c0-.5.438-1 1-1h14c.5 0 1 .5 1 1 0 .563-.5 1-1 1h-14c-.562 0-1-.438-1-1zm13 5c.5 0 1 .5 1 1 0 .563-.5 1-1 1h-12c-.562 0-1-.438-1-1 0-.5.438-1 1-1h12zm-4 6c.5 0 1 .5 1 1 0 .563-.5 1-1 1h-8c-.562 0-1-.438-1-1 0-.5.438-1 1-1h8zm16.75.313c.375-.375 1.063-.375 1.438 0s.375 1.062 0 1.437l-4.5 4.5c-.375.375-1.063.375-1.438 0l-2.5-2.5c-.375-.375-.375-1.063 0-1.438s1.063-.375 1.438 0l1.812 1.813 3.75-3.813zM18.333 23c0-4.938 4-9 9-9 4.938 0 9 4.063 9 9 0 5-4.062 9-9 9-5 0-9-4-9-9zm9 7c3.813 0 7-3.125 7-7 0-3.813-3.187-7-7-7-3.875 0-7 3.188-7 7 0 3.875 3.125 7 7 7z"
    />
  </svg>
);

export const ReplacementCarsIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 32"
    width="1em"
    height="1em"
  >
    <path
      fill="currentColor"
      d="M7.75 0h8.438a4.013 4.013 0 013.875 2.938l1.312 4.75C22.063 8 22.563 8.5 23 9.063c-.75.124-1.438.312-2.125.687C20.375 9.312 19.687 9 19 9H5a3 3 0 00-3 3v4h15.188l-.375 1.375c-.25.188-.5.438-.75.625H2v2c0 .563-.5 1-1 1-.563 0-1-.438-1-1v-8c0-1.875 1-3.5 2.563-4.313l1.312-4.75A4.013 4.013 0 017.75 0zm0 2c-.938 0-1.688.625-1.938 1.5l-1 3.5h14.313l-1-3.5c-.25-.875-1-1.5-1.938-1.5H7.75zM3.5 12.5c0-.813.625-1.5 1.5-1.5.813 0 1.5.688 1.5 1.5 0 .875-.688 1.5-1.5 1.5-.875 0-1.5-.625-1.5-1.5zm16 11c0-.813.625-1.5 1.5-1.5.813 0 1.5.688 1.5 1.5 0 .875-.688 1.5-1.5 1.5-.875 0-1.5-.625-1.5-1.5zm17 0c0 .875-.688 1.5-1.5 1.5-.875 0-1.5-.625-1.5-1.5 0-.813.625-1.5 1.5-1.5.813 0 1.5.688 1.5 1.5zM23.75 11h8.438a4.013 4.013 0 013.874 2.938l1.313 4.75A4.855 4.855 0 0140 23v8c0 .563-.5 1-1 1-.563 0-1-.438-1-1v-2H17.937v2c0 .563-.437 1-1 1-.5 0-1-.438-1-1v-8c0-1.875 1.063-3.5 2.626-4.313l1.312-4.75A4.013 4.013 0 0123.75 11zm0 2c-.938 0-1.688.625-1.938 1.5l-1 3.5h14.313l-1-3.5c-.25-.875-1-1.5-1.938-1.5H23.75zM38 23c0-1.625-1.375-3-3-3H21a3 3 0 00-3 3v4h20v-4z"
    />
  </svg>
);

export const ClipboardCheckIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 32"
    width="1em"
    height="1em"
  >
    <path
      fill="currentColor"
      d="M19.667 21h-8c-.563 0-1 .5-1 1 0 .563.437 1 1 1h8c.5 0 1-.438 1-1 0-.5-.5-1-1-1zm0-6h-6c-.563 0-1 .5-1 1 0 .563.437 1 1 1h6c.5 0 1-.438 1-1 0-.5-.5-1-1-1zm-13 5.5c-.875 0-1.5.688-1.5 1.5 0 .875.625 1.5 1.5 1.5.812 0 1.5-.625 1.5-1.5 0-.813-.688-1.5-1.5-1.5zm14-16.5c-.563 0-1 .5-1 1 0 .563.437 1 1 1 1.062 0 2 .938 2 2v20c0 1.125-.938 2-2 2h-16c-1.125 0-2-.875-2-2V8c0-1.063.875-2 2-2 .5 0 1-.438 1-1 0-.5-.5-1-1-1-2.25 0-4 1.813-4 4v20c0 2.25 1.75 4 4 4h16c2.187 0 4-1.75 4-4V8c0-2.188-1.813-4-4-4zm-13 4h10c.5 0 1-.438 1-1 0-.5-.5-1-1-1h-1.563c.313-.563.563-1.25.563-2 0-2.188-1.813-4-4-4-2.25 0-4 1.813-4 4 0 .75.187 1.438.5 2h-1.5c-.563 0-1 .5-1 1 0 .563.437 1 1 1zm5-6c1.062 0 2 .938 2 2 0 1.125-.938 2-2 2-1.125 0-2-.875-2-2 0-1.063.875-2 2-2zm-7.75 12.375a.93.93 0 00.062 1.375l2.125 2c.188.188.438.25.688.25.25 0 .562-.063.75-.25l3.812-4c.375-.438.375-1.063 0-1.438-.437-.374-1.062-.374-1.437 0l-3.188 3.313-1.437-1.313a.93.93 0 00-1.375.063z"
    />
  </svg>
);

export const GarageIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 41 32"
    width="1em"
    height="1em"
  >
    <path
      fill="currentColor"
      d="M20.708 2.25a1.784 1.784 0 00-.812 0L3.52 9.188c-.75.312-1.188 1-1.188 1.812v20c0 .563-.5 1-1 1-.562 0-1-.438-1-1V11c0-1.563.938-3.063 2.438-3.688L19.146.438a2.97 2.97 0 012.312 0l16.375 6.875c1.5.625 2.5 2.125 2.5 3.688v20c0 .563-.5 1-1 1-.562 0-1-.438-1-1V11c0-.813-.5-1.5-1.25-1.813L20.708 2.25zM6.333 14c0-1.063.875-2 2-2h24c1.063 0 2 .938 2 2v17c0 .563-.5 1-1 1-.562 0-1-.438-1-1V14h-24v17c0 .563-.5 1-1 1-.562 0-1-.438-1-1V14zm10.5 12c0 .563-.5 1-1 1-.562 0-1-.438-1-1 0-.5.438-1 1-1 .5 0 1 .5 1 1zm7 0c0-.5.438-1 1-1 .5 0 1 .5 1 1 0 .563-.5 1-1 1-.562 0-1-.438-1-1zm2.563-7.875l1.312 3.938c.938.625 1.625 1.75 1.625 2.937v6c0 .563-.5 1-1 1-.562 0-1-.438-1-1v-1h-14v1c0 .563-.5 1-1 1-.562 0-1-.438-1-1v-6c0-1.188.625-2.313 1.563-2.938l1.312-3.937c.375-1.25 1.563-2.125 2.875-2.125h6.438c1.312 0 2.5.875 2.875 2.125zM15.208 21.5h10.188l-.875-2.75c-.188-.438-.563-.75-1-.75h-6.438c-.437 0-.812.313-1 .75l-.875 2.75zM13.333 28h14v-3c0-.813-.687-1.5-1.5-1.5h-11c-.875 0-1.5.688-1.5 1.5v3z"
    />
  </svg>
);

/*!
 * Font Awesome Free v7.3.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0)
 * Copyright 2026 Fonticons, Inc.
 */
export const QuestionMarkCircleIcon = (props: { className?: string }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    viewBox="0 0 640 640"
    width="1em"
    height="1em"
  >
    <path
      fill="currentColor"
      d="M320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM320 240C302.3 240 288 254.3 288 272C288 285.3 277.3 296 264 296C250.7 296 240 285.3 240 272C240 227.8 275.8 192 320 192C364.2 192 400 227.8 400 272C400 319.2 364 339.2 344 346.5L344 350.3C344 363.6 333.3 374.3 320 374.3C306.7 374.3 296 363.6 296 350.3L296 342.2C296 321.7 310.8 307 326.1 302C332.5 299.9 339.3 296.5 344.3 291.7C348.6 287.5 352 281.7 352 272.1C352 254.4 337.7 240.1 320 240.1zM288 432C288 414.3 302.3 400 320 400C337.7 400 352 414.3 352 432C352 449.7 337.7 464 320 464C302.3 464 288 449.7 288 432z"
    />
  </svg>
);

export const SnowflakeIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    width="1em"
    height="1em"
  >
    <path
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 3v26M4.74 9.5l22.52 13M4.74 22.5l22.52-13M16 6l3.9-2.25M16 6l-3.9-2.25M16 26l3.9 2.25M16 26l-3.9 2.25M24.66 21v4.5M24.66 21l3.9-2.25M7.34 11V6.5M7.34 11l-3.9 2.25M24.66 11l3.9 2.25M24.66 11V6.5M7.34 21l-3.9-2.25M7.34 21v4.5"
    />
  </svg>
);
